import React from 'react'
import SimpleImageTest from '../components/test/SimpleImageTest'

const SimpleImageTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SimpleImageTest />
    </div>
  )
}

export default SimpleImageTestPage